import { NgModule } from '@angular/core';
import { IndorseExtensionComponent } from './indorse-extension.component';
import { ExtensionService } from '@alfresco/adf-extensions';
import { IndorseExtensionService } from './indorse-extension.service';

@NgModule({
  declarations: [IndorseExtensionComponent],
  imports: [],
  exports: [IndorseExtensionComponent],
  entryComponents: [IndorseExtensionComponent],
  providers: [IndorseExtensionService]
})
export class IndorseExtensionModule {
  constructor(extensions: ExtensionService) {
    extensions.setComponents({
      'indorse-extension.main.component': IndorseExtensionComponent,
    });
  }
}
